module.exports = __webpack_public_path__ + "img/carousel_five_bg.0.1.0_202503250930.png";